const imageAddr =
  'https://ducip.megafon.ru/system/banners/1812/2af4ce077f179e1e70f0395b56ad7551.png';
//'http://moscow.megafon.ru/b-general-topline/i/megafon-logo-green.svg';

const downloadSize = 164237;

export default () => {
  return new Promise(resolve => {
    const startTime = Date.now();
    let download = new Image();

    download.onload = function() {
      const endTime = Date.now();

      const duration = (endTime - startTime) / 1000;
      const bitsLoaded = downloadSize * 8;
      const speedBps = (bitsLoaded / duration).toFixed(2);
      const speedKbps = (speedBps / 1024).toFixed(2);
      const speedMbps = (speedKbps / 1024).toFixed(2);
      const speedMBps = (speedMbps / 1024).toFixed(2);

      resolve({
        speedBps,
        speedKbps,
        speedMbps,
        speedMBps,
      });
    };

    download.src = imageAddr + '?n=' + Math.random();
  });
};
